// Per-account feature names reported by `/api/auth/me` as `features`
// (lib/auth.jsx `hasFeature`). A name missing from that list is OFF.
//
// Named once so the Home door, its shortcut and the /upload route cannot drift
// apart on a typo. Must match backend/app/routers/ocr.py SCORECARD_IMPORT_FLAG.
export const SCORECARD_IMPORT_FEATURE = "ocr_scorecard_import";
